<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">平台资源(小程序)</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">平台课程</a>
        </span>
      </div>
      <div class="framePage-body">
        <el-tabs v-model="activeName" :before-leave="beforeTabLeave" @tab-click="tabChange">
          <el-tab-pane label="平台课程" name="first">
            <CourseList ref="first" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
// courseList
import CourseList from "../platform/popup/course";
import { resetKeepAlive } from "@/utils/common";
export default {
  name: "platFormCourseList",
  components: {
    CourseList
  },
  data() {
    return {
      activeName: "first"
    };
  },
  created() {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      const query = this.$route.query;
      if (query.active) {
        this.activeName = query.active;
      } else {
        this.activeName = "first";
      }
    },
    tabChange(tab) {
      this.$refs[tab.name].searchName = "";
      this.$refs[tab.name].params = {};
      this.$refs[tab.name].ruleForm.Trainingtype = "";
      this.$refs[tab.name].completeState = "";
      this.$refs[tab.name].getData();
    },
    beforeTabLeave(newName) {
      this.$router.replace({
        path: this.$route.path,
        query: { active: newName }
      });
    }
  },
  beforeRouteLeave: resetKeepAlive,
  watch: {
    // 监听缓存后调用接口
    $route:function(route){
      if(route.name !='courseList') return;
      if(route.params.refresh){
        this.$refs[route.params.refName].getData(-1);
      }
      // this.activeName = route.params.refName;
    }
  }
};
</script>
<style lang="less">
</style>
